import { render, staticRenderFns } from "./globalTpt.vue?vue&type=template&id=3f83d83a&scoped=true&"
import script from "./globalTpt.vue?vue&type=script&lang=js&"
export * from "./globalTpt.vue?vue&type=script&lang=js&"
import style0 from "./globalTpt.vue?vue&type=style&index=0&id=3f83d83a&lang=less&scoped=true&"
import style1 from "./globalTpt.vue?vue&type=style&index=1&id=3f83d83a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f83d83a",
  null
  
)

export default component.exports